<template>
  <div>
    <ul
      class="tabs__header"
      :class="{ tabs__two: mode === 'two', tabs__three: mode === 'three' }"
    >
      <li
        class="tabs__item"
        v-for="(tab, index) in tabs"
        :key="tab.title"
        @click="selectTab(index)"
        :class="{ tab__active: index == selectedIndex }"
      >
        <h6 :class="{ 'tabs__header--upperCase': upperCase }">
          {{ tab.title }}
        </h6>
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      default: "two",
    },
    upperCase: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedIndex: 0,
      tabs: [],
    };
  },
  created() {
    this.tabs = this.$children;
  },
  mounted() {
    this.selectTab(0);
  },
  methods: {
    selectTab(i) {
      this.selectedIndex = i;
      this.tabs.forEach((tab, index) => {
        tab.isActive = index === i;
      });
    },
  },
};
</script>

<style scoped>
.tabs__header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
}

.tabs__item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tabs__two .tabs__item {
  width: 636px;
  height: 55px;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("../../assets/image/about/flap-light.png");
}

.tabs__three .tabs__item {
  width: 33%;
  height: 55px;
  background-position: top center;
  background-repeat: no-repeat;
  background-image: url("../../assets/image/about/gray-tab3.png");
}

.tabs__item h6 {
  font-family: "Seravek-Medium";
  text-align: center;
  font-size: 22px;
  color: var(--text-color);
  margin-bottom: 0;
}

.tabs__item h6.tabs__header--upperCase {
  text-transform: uppercase;
}

.tab__active h6 {
  color: var(--secondary-color);
}
.tabs__two .tab__active {
  background: url("../../assets/image/about/flap.png");
  background-position: top center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 55px;
}

.tabs__three .tab__active {
  background: url("../../assets/image/about/red-tab3.png");
  background-position: top center;
  height: 55px;
  background-repeat: no-repeat;
}
@media (min-width: 320px) and (max-width: 767px) {
  .tabs__item h6 {
    font-size: 16px;
  }
  .tabs__two .tabs__item {
    width: 50%;
    background-size: cover;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .tabs__item h6 {
    font-size: 18px;
  }
  .tabs__two .tabs__item {
    width: 50%;
    background-size: cover;
  }
  .tabs__three .tabs__item,
  .tabs__three .tab__active {
    width: 33%;
    background-size: cover;
    height: 66px;
  }
}
</style>
